/**
 * The four stock classes. Spec 014, FR-1401.
 *
 * Guy, 29 October 2026: "Stock line, non-request item, Run-out and Archived".
 * The label of the second is "On request" (decided 30 October; spec 014
 * section 12 keeps the question for Guy). One list, so the panel, the grid,
 * its filter, the bulk file and the help say the same words.
 *
 * The database holds the rules: `items_line_status_check`, active follows the
 * class, and no archive while stock is on hand or reserved (migration
 * 20261030002201).
 */
export const STOCK_CLASSES = ['stock_line', 'on_request', 'run_out', 'archived'] as const;

export type StockClass = (typeof STOCK_CLASSES)[number];

export const CLASS_WORD: Record<StockClass, string> = {
  stock_line: 'Stock line',
  on_request: 'On request',
  run_out: 'Run-out',
  archived: 'Archived',
};

/** What each class does, in the words of the item panel and the help. */
export const CLASS_MEANS: Record<StockClass, string> = {
  stock_line: 'kept in stock and reordered',
  on_request: 'bought when a customer asks, not reordered',
  run_out: 'sell what is left, do not reorder',
  archived: 'not in use, kept for history',
};

export function isStockClass(v: unknown): v is StockClass {
  return typeof v === 'string' && (STOCK_CLASSES as readonly string[]).includes(v);
}

export function classWord(v: string | null | undefined): string {
  return isStockClass(v) ? CLASS_WORD[v] : 'Stock line';
}
